// components/NotificationDialog.tsx
"use client";

import LoadingIcon from "@/app/assets/icons/loading";
import { Dialog, DialogContent, DialogFooter } from "@/components/ui/dialog";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

interface NotificationDialogProps {
    open: boolean;
    onAccept: () => void;
    onDecline: () => void;
}

const NotificationDialog: React.FC<NotificationDialogProps> = ({ open, onAccept, onDecline }) => {
    const pathname = usePathname();
    const [isDisabled, setisDisabled] = useState<boolean>(false);
    const [isAdvisory, setisAdvisory] = useState<boolean>(false);

    // Add useEffect to check URL pathname
    useEffect(() => {
        if (pathname && pathname.includes("/advisory")) {
            setisAdvisory(true);
        }
    }, []);

    // Don't render anything if the pathname contains 'advisory'
    if (pathname?.includes("advisory")) {
        return <></>;
    }


    // Don't render anything if the pathname contains 'advisory'
    if (pathname?.includes("advisory")) {
        return <></>;
    }

    return (
        !isAdvisory && (
            <Dialog open={open}>
                <DialogContent className="w-[80%] !rounded-xl md:max-w-md [&>button:last-child]:hidden">
                    <div className="flex flex-col gap-1 md:gap-3">
                        <h2 className="text-base font-semibold md:text-xl">Enable Notifications</h2>
                        <p className="text-sm text-muted-foreground md:text-base">
                            Would you like to enable browser notifications for alerts and updates?
                        </p>
                    </div>
                    <DialogFooter className="flex flex-row justify-between gap-2 md:justify-end">
                        {!isDisabled && (
                            <RegularButton
                                variant={ButtonVariant.SecondaryDefault}
                                size={ButtonSize.Medium}
                                label="No"
                                onClick={onDecline}
                                noIcon={true}
                                showRightIcon={false}
                            />
                        )}
                        <RegularButton
                            variant={ButtonVariant.PrimaryDefault}
                            size={ButtonSize.Medium}
                            label={isDisabled ? "" : "Yes"}
                            disabled={isDisabled}
                            onClick={() => {
                                setisDisabled(true);
                                onAccept();
                            }}
                            icon={<LoadingIcon className="animate-spin" />}
                            noIcon={isDisabled ? false : true}
                            showRightIcon={false}
                        />
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        )
    );
};

export default NotificationDialog;